export function errorPanel() {
    let panelData = {};
    var panel = "#validation-panel";
    var actionKeys = {
        r: "rekeyed",
        o: "overridden",
        q: "queried"
    };
    function getData() {
        return panelData;
    }
    function setState(data) {
        panelData = data;
        var display = Object.keys(data).length && !VR.Common.IsMobile() ? "block" : "none";
        $(panel).css("display", display);

        window.React.Render(
            document.getElementById("validation-panel"),
            window.React.Components.ValidationPanel,
            {
                errorData: data
            }
        );
    }
    function showActionKey(k, isHardEdit, model, isValidationErr) {
        var show = false;
        if (isValidationErr) {
            show = k === "R";
        } else {
            if (k === "R") {
                show = true;
            } else if (k === "Q") {
                show = !(isHardEdit || model.ByPassValue);
            } else if (k === "O") {
                show = !(isHardEdit || model.ByPassValue) && model.CanOverride;
            }
        }
        return show;
    }
    function showBypassKey(bypass, isHardEdit, model, isValidationErr) {
        return (
            !isValidationErr &&
            (!model ||
                (!isHardEdit &&
                    model.ByPassValue &&
                    !model.AllowUnknown &&
                    model.ByPassValue.indexOf(bypass.toString()) > -1))
        );
    }
    function resetError(FieldId) {
        let errorData = getData();
        delete errorData[FieldId];
        setState(errorData);
    }
    return {
        resetError,
        /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
            /// <summary>
            /// Shows validation error section.
            /// Hard/Soft Edit - Hard: Allow rekey or temporarily skip; Soft: Shows rekey, skip, override and query -- however if bypass vars are present then override and query are not shown. 
            /// </summary>
            /// <param name="field">The input element.</param>
            /// <param name="model">The field model.</param>
            /// <param name="message">The error message.</param>
            /// <param name="location">The query location.</param>
            /// <param name="isHardEdit">The value to indicate if this is a hard edit.</param>
            /// <returns></returns>*/
        setError: function (error) {
            var field = error.field;
            var model = error.model;
            var message =
                typeof error.message === "string"
                    ? error.message
                    : "Unexpected error occured, please contact your administrator.";
            var location = error.location;
            var isHardEdit = error.isHardEdit;
            var isValidationErr = error.errorType === "validation";

            var errorData = getData();
            var bypassButtons = [
                {
                    title: "Queried and verified",
                    txt: "1"
                },
                {
                    title: "Queried not verified",
                    txt: "2"
                },
                {
                    title: "Review needed",
                    txt: "3"
                },
                {
                    title: "Query needed",
                    txt: "4"
                }
            ].map(function (b) {
                return $.extend({}, b, {
                    placement: "bottom-end",
                    className: "bypassBtn",
                    show: showBypassKey(b.txt, isHardEdit, model, isValidationErr)
                });
            });
            var actionButtons = [
                {
                    title: "Rekey",
                    txt: "R"
                },
                {
                    title: "Override",
                    txt: "O"
                },
                {
                    title: "Query",
                    txt: "Q"
                }
            ].map(function (b) {
                return $.extend({}, b, {
                    placement: "bottom-start",
                    className: "btn" + b.txt,
                    show: showActionKey(b.txt, isHardEdit, model, isValidationErr)
                });
            });
            let timeAdded = errorData[model.FieldId]
                ? errorData[model.FieldId].timeAdded
                : new Date();
            errorData[model.FieldId] = {
                required: model.IsRequired,
                link: {
                    breadCrumbs: [model.Tab, model.Section, model.FieldLabel],
                    onclick: function () {
                        resetError(model.FieldId);
                        VR.Edit.TakeActionOnField(
                            "rekeyed",
                            message,
                            location,
                            field,
                            model
                        );
                    }
                },
                location: location || "",
                message: message,
                actionButtons: {
                    buttons: actionButtons,
                    events: {
                        onkeydown: VR.Edit.FieldKeyDown,
                        onkeypress: function (e) {
                            e.preventDefault();
                            var key = actionKeys[e.key.toLowerCase()];
                            if (
                                key &&
                                showActionKey(
                                    e.key.toUpperCase(),
                                    isHardEdit,
                                    model,
                                    isValidationErr
                                )
                            ) {
                                resetError(model.FieldId);
                                VR.Edit.TakeActionOnField(key, message, location, field, model);
                            }
                        },
                        onclick: function (e, btn) {
                            var txt = btn.txt;
                            var key = actionKeys[txt.toLowerCase()];
                            if (key) {
                                resetError(model.FieldId);
                                VR.Edit.TakeActionOnField(key, message, location, field, model);
                            }
                        }
                    }
                },
                bypassButtons: {
                    buttons: bypassButtons,
                    events: {
                        onclick: function (e, btn) {
                            resetError(model.FieldId);
                            var data = btn.txt;
                            var inputs = VR.Edit.GetInputFields(model.FieldName + "_BYPASS");
                            if (inputs.length > 0) {
                                VR.Edit.SetFieldValue(inputs[0], data, true);
                            }

                            inputs = VR.Edit.GetInputFields(model.FieldName + "_MVR");
                            if (inputs.length > 0) {
                                VR.Edit.SetFieldValue(inputs[0], "", true);
                            }

                            var status = "queried";
                            if (data == "1") {
                                status = "overridden";
                            }
                            VR.Edit.TakeActionOnField(status, message, location, field, model);
                            model.HasSaveError = false;
                            VR.Script.FocusField(nx.LastFocus, true);
                        }
                    }
                },
                missingValues: {
                    show: !!model.HasMissingVariable,
                    value: "Caption",
                    key: "Key",
                    dataSource: VR.Edit.MissingValues,
                    defaultValue: function () {
                        return VR.Edit.GetFieldValue(model.FieldName + "_MVR");
                    },
                    events: {
                        onChange: function (e) {
                            var value = e.target.value;
                            if (!value) {
                                return;
                            }
                            var inputs = VR.Edit.GetInputFields(model.FieldName + "_MVR");
                            if (inputs.length > 0) {
                                VR.Edit.SetFieldValue(inputs[0], value, true);
                            }
                            VR.Edit.SetStatus(field, model, "unknown", message, location);
                            VR.Script.FocusField(nx.LastFocus, true);
                        }
                    }
                },
                timeAdded
            };
            setState(errorData);
        }
    };
}
